module.exports = "/_next/static/images/e7965187fe57981294948eb910f5565b-mgm-lg-2.png";